import {LocaleDictionaryRegistrationPage} from "../../interface/registrationPage";
import {PersonalAgreement} from "../ru/personalAgreement";

export const registrationPage: LocaleDictionaryRegistrationPage = {
    checkBoxCaption1: 'I give my ',
    checkBoxCaptionLink: 'consent to the processing of personal data and join the electronic interaction',
    checkBoxCaption2: 'I am joining the',
    checkBoxCaptionLink2: 'electronic interaction',
    checkBoxCaption3: 'I am familiar',
    checkBoxCaptionLink3: 'with the personal data processing policy',
    agreementTitle: 'Согласие на обработку персональных данных и соглашение об электронном взаимодействии',
    agreementTitle2: 'Политика конфиденциальности',
    agreementText: PersonalAgreement,
    personalDataProcessingLink: 'https://privacypolicy.rudn.ru/consent_to_the_processing_of_personal_data.html',
    electronicInteractionAgreement: 'https://privacypolicy.rudn.ru/agreement_between_participants_in_electronic_interaction.htm',
    personalDataPolicyLink: 'https://privacypolicy.rudn.ru/personal_data_processing_policy.pdf',
}
